<!-- 做题记录 -->
<template>
<van-popup v-model="show" class="lxjl-popup list-popup" position="right" :overlay-style="{background: '#fff'}">
    <div class="list-nav">
        <van-icon name="arrow-left" @click="handleClose" />
        <div class="nav-name">做题记录</div>
    </div>
    <!-- <el-scrollbar class="subject-item-box">
        <div class="subject-item" @click="handleChangeActiveSubject(item)" v-for="(item) in tabList" :key="item.code" :class="{active: item.code === activeSubject.code}">{{ item.name }}</div>
    </el-scrollbar> -->
    <div class="subject-box">
        <div class="subject-name">{{ activeSubject.name }}</div>
        <div class="handle" @click="handleOpenChangeSubject">
            <img class="handle-icon" :src="require('@/common/images/mSpecialTopic/change_icon.png')" />
            <div class="handle-label">切换科目</div>
        </div>
    </div>
    <van-tabs v-model="active" class="tabs" @change="handleTabsChange">
        <van-tab :title="item.sectionname" v-for="(item) in activeSubject.tabList" :key="item.sectioncode">
            <van-list v-model="item.loadingmore" :finished="item.finished" class="content-scroll" @load="handleVanlistLoad" :offset="100">
                <div class="item" v-for="(option) in item.list" :key="option.catecode">
                    <div class="name-count">
                        <div class="catename">{{ option.examname }}</div>
                        <div class="datcount">{{ option.datetime }}</div>
                    </div>
                    <div class="do-exam-icon-box">
                        <!-- <img class="do-exam-icon" :src="require('@/common/images/mSpecialTopic/do_exam_icon.png')" /> -->
                        <img class="do-exam-icon" v-if="option.examstatus === 0" @click="handleStartExam(option, item.sectioncode)" :src="require('@/common/images/mSpecialTopic/do_exam_icon.png')" />
                        <div class="again-exam" v-if="option.examstatus === 10" @click="handleStartExam(option, item.sectioncode)">重做</div>
                        <div class="continue-exam" v-if="option.examstatus === 1" @click="handleContinueExam(option, item.sectioncode)">继续</div>
                    </div>
                </div>
                <div class="empty-data" v-if="!item.list.length && item.finished">
                    <img class="icon" :src="require('@/common/images/mSpecialTopic/empty_data_icon.png')" />
                    <div class="text">空空如也</div>
                </div>
            </van-list>
        </van-tab>
    </van-tabs>
    <ChangeSubject ref="changeSubject" @handleSubjectChange="handleSubjectChange"></ChangeSubject>
</van-popup>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
import {getTopicUserExamErrorList, updateTopicUserSpecialStartExam} from '@/api/specialTopic.js'
import {getTopicUserExamListV2, updateTopicUserExamDayTrainStartExam} from '@/api/specialTopic.js'
import {updateStartExam} from '@/api/questionbank.js'
import {mapActions, mapGetters} from 'vuex'
import ChangeSubject from '../component/changeSubject.vue'
export default {
    data() {
        return {
            show: false,
            active: 0,
            tabList: [],
            activeSubject: {
                code: this.$route.query.subjectcode ? this.$route.query.subjectcode : '',
                init: false,
                tabList: []
            },
            requestIng: false
        }
    },
    props: {
        subjectList: {
            type: Array,
            required: true,
            default: () => {
                return specialTopic.subject[this.$route.params.examcode]
            }
        }
    },
    components: {
        ChangeSubject
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {

    },
    methods: {
        handleOpen() {
            this.show = true
            this.handleInit()
        },
        handleClose() {
            this.show = false
        },
        handleInit() {
            if (this.activeSubject.tabList[this.active] && !this.activeSubject.tabList[this.active].init) {
                this.handleGetTopicUserExamListV2()
            }
        },
        handleChangeActiveSubject(item) {
            if (item.code !== this.activeSubject.code) {
                this.active = 0
                this.activeSubject = JSON.parse(JSON.stringify(item))
                if (!this.activeSubject.tabList[this.active].init) {
                    this.activeSubject.tabList[this.active].pageParams.page = 1
                    this.handleGetTopicUserExamListV2()
                }
            }
        },
        handleOpenChangeSubject() {
            this.$refs.changeSubject.handleOpen(this.$route.params.examcode, this.activeSubject.code)
        },
        handleSubjectChange(subjectcode) {
            if (subjectcode !== this.activeSubject.code) {
                this.tabList.some(item => {
                    if (item.code === subjectcode) {
                        this.handleChangeActiveSubject(item)
                        return true
                    }
                })
            }
        },
        handleTabsChange() {
            if (!this.activeSubject.tabList[this.active].init) {
                this.activeSubject.tabList[this.active].pageParams.page = 1
                this.handleGetTopicUserExamListV2()
            }
        },
        handleVanlistLoad() {
            if (!this.activeSubject.tabList[this.active].init && !this.activeSubject.tabList[this.active].finished && this.activeSubject.tabList[this.active].pageParams.page < this.activeSubject.tabList[this.active].pageinfo.pageCount) {
                this.activeSubject.tabList[this.active].pageParams.page++
                this.handleGetTopicUserExamListV2()
            }
        },
        handleGetTopicUserExamListV2() {
            if (this.requestIng) {
                return
            }
            this.requestIng = true
            let params = {
                condition: {
                    catecode: '',
                    examcode: this.$route.params.examcode,
                    sectioncode: this.activeSubject.tabList[this.active].sectioncode,
                    subjectcode: this.activeSubject.code
                },
                page: this.activeSubject.tabList[this.active].pageParams.page,
                pagesize: this.activeSubject.tabList[this.active].pageParams.pagesize,
                orderbyname: '',
                orderbyorder: ''
            }
            if (params.page === 1) {
                this.setLoading(true)
            } else {
                this.activeSubject.tabList[this.active].loadingmore = true
            }
            getTopicUserExamListV2({
                data: params,
                success: data => {
                    if (params.page === 1) {
                        this.activeSubject.tabList[this.active].list = data.data
                        this.activeSubject.tabList[this.active].total = data.pageableData.rowCount
                        this.activeSubject.tabList[this.active].pageinfo = data.pageableData
                    } else {
                        this.activeSubject.tabList[this.active].list = this.activeSubject.tabList[this.active].list.concat(data.data)
                    }
                    if (this.activeSubject.tabList[this.active].list.length >= this.activeSubject.tabList[this.active].total) {
                        this.activeSubject.tabList[this.active].finished = true
                    } else {
                        this.activeSubject.tabList[this.active].finished = false
                    }
                    this.activeSubject.tabList[this.active].init = true
                    this.tabList.some(item => {
                        if (item.code === this.activeSubject.code) {
                            item.tabList = JSON.parse(JSON.stringify(this.activeSubject.tabList))
                        }
                    })
                    this.setLoading(false)
                    this.activeSubject.tabList[this.active].loadingmore = false
                    this.requestIng = false
                },
                error: error => {
                    this.setLoading(false)
                    this.activeSubject.tabList[this.active].loadingmore = false
                    this.$toast.fail(error.msg)
                }
            })
        },
        // 开始做题/重新做题
        handleStartExam(item, sectioncode) {
            if (sectioncode === '0100') {
                this.setLoading(true)
                updateTopicUserExamDayTrainStartExam({
                    data: {
                        code: item.keycode,
                        examcode: this.$route.params.examcode,
                        subjectcode: this.activeSubject.code,
                        traindate: ''
                    },
                    success: data => {
                        this.setLoading(false)
                        item.status = 1
                        item.recentexamcode = data.data
                        sessionStorage.setItem('specialTopicMrylCode', item.code)
                        this.$router.push({
                            name: 'MSpecialTopicExam',
                            params: {
                                examsource: 1,
                                examcode: this.$route.params.examcode
                            },
                            query: {
                                examid: data.data,
                                source: 'lxjl',
                                subjectcode: this.activeSubject.code
                            }
                        })
                    },
                    error: error => {
                        this.setLoading(false)
                        this.$message.error(error.msg)
                    }
                })
            } else if (sectioncode === '0101' || sectioncode === '0102' || sectioncode === '0103') {
                this.setLoading(true)
                updateStartExam({
                    data: {
                        topiccode: this.$route.params.examcode,
                        subjectcode: this.activeSubject.code,
                        sectioncode: sectioncode,
                        assetinnerid: item.bankid,
                        taskid: sectioncode === '0101' ? item.taskid : '',
                        examid: ''
                    },
                    success: data => {
                        this.setLoading(false)
                        item.examstatus = 1
                        item.examid = data.data
                        this.$router.push({
                            name: 'MSpecialTopicExam',
                            params: {
                                examsource: this.sectioncode === '0101' ? 2 : (this.sectioncode === '0102' ? 3 : 4),
                                examcode: this.$route.params.examcode
                            },
                            query: {
                                examid: data.data,
                                source: 'lxjl',
                                subjectcode: this.activeSubject.code
                            }
                        })
                    },
                    error: error => {
                        this.setLoading(false)
                        this.$message.error(error.msg)
                    }
                })
            }
        },
        // 继续做题
        handleContinueExam(item, sectioncode) {
            if (sectioncode === '0100') {
                sessionStorage.setItem('specialTopicMrylCode', '')
                this.$router.push({
                    name: 'MSpecialTopicExam',
                    params: {
                        examsource: 1,
                        examcode: this.$route.params.examid
                    },
                    query: {
                        examid: item.recentexamcode,
                        source: 'lxjl',
                        subjectcode: this.activeSubject.code
                    }
                })
            } else if (sectioncode === '0101' || sectioncode === '0102' || sectioncode === '0103') {
                this.$router.push({
                    name: 'MSpecialTopicExam',
                    params: {
                        examsource: sectioncode === '0101' ? 2 : (sectioncode === '0102' ? 3 : 4),
                        examcode: this.$route.params.examcode
                    },
                    query: {
                        examid: item.examid,
                        source: 'lxjl',
                        subjectcode: this.activeSubject.code
                    }
                })
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    watch: {
        subjectList: {
            handler(newV) {
                if (newV && newV.length) {
                    let subjectlist = JSON.parse(JSON.stringify(newV))
                    subjectlist.forEach(item => {
                        item.tabList = [
                            {sectionname: '每日一练', sectioncode: '0100', init: false, list: [], pageParams: {page: 1, pagesize: 10}, pageinfo: {pageCount: 1,pageNum: 1,pageSize: 10,rowCount: 0}, total: 0, loadingmore: false, finished: !this.user.loginToken ? true : false},
                            {sectionname: '章节练习', sectioncode: '0101', init: false, list: [], pageParams: {page: 1, pagesize: 10}, pageinfo: {pageCount: 1,pageNum: 1,pageSize: 10,rowCount: 0}, total: 0, loadingmore: false, finished: !this.user.loginToken ? true : false},
                            {sectionname: '历年真题', sectioncode: '0102', init: false, list: [], pageParams: {page: 1, pagesize: 10}, pageinfo: {pageCount: 1,pageNum: 1,pageSize: 10,rowCount: 0}, total: 0, loadingmore: false, finished: !this.user.loginToken ? true : false},
                            {sectionname: '模拟试题', sectioncode: '0103', init: false, list: [], pageParams: {page: 1, pagesize: 10}, pageinfo: {pageCount: 1,pageNum: 1,pageSize: 10,rowCount: 0}, total: 0, loadingmore: false, finished: !this.user.loginToken ? true : false}
                        ]
                    })
                    if (this.activeSubject.code) {
                        let flag = false
                        subjectlist.some(item => {
                            if (item.code === this.activeSubject.code) {
                                this.activeSubject = JSON.parse(JSON.stringify(item))
                                flag = true
                                return true
                            }
                        })
                        if (!flag) {
                            this.activeSubject = JSON.parse(JSON.stringify(subjectlist[0]))
                        }
                    } else {
                        this.activeSubject = JSON.parse(JSON.stringify(subjectlist[0]))
                    }
                    this.tabList = JSON.parse(JSON.stringify(subjectlist))
                    if (this.$route.query.section === 'lxjl') {
                        this.handleInit()
                    }
                }
            },
            deep: true,
            immediate: true
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.lxjl-popup {
    width: 100vw;
    height: 100vh;
    background: #F8F8F8;
    overflow: hidden;
    .list-nav {
        background: #fff;
        height: 0.88rem;
        padding: 0 0.32rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        box-shadow: 0px 0.02rem 0.06rem 0px rgba(0,0,0,0.1);
        .van-icon {
            font-size: 0.4rem;
            position: relative;
            z-index: 12;
        }
        .nav-name {
            position: absolute;
            z-index: 11;
            width: 100%;
            left: 0;
            line-height: 0.88rem;
            text-align: center;
            font-size: 0.34rem;
            color: #333333;
            font-weight: bold;
            box-sizing: border-box;
        }
    }
    .subject-item-box {
        height: 0.8rem;
        .el-scrollbar__view {
            display: flex;
            height: 0.8rem;
            .subject-item {
                padding: 0 0.35rem;
                line-height: 0.8rem;
                font-size: 0.3rem;
                color: #333333;
                white-space: nowrap;
                background: #fff;
                &.active {
                    color: #1D60AD;
                    background: rgba(29,96,173,0.1);
                    font-weight: bold;
                }
            }
        }
    }
    .subject-box {
        height: 0.8rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 0.28rem;
        box-sizing: border-box;
        background: #fff;
        .subject-name {
            font-size: 0.3rem;
            color: #333333;
            font-weight: bold;
        }
        .handle {
            display: flex;
            align-items: center;
            .handle-icon {
                width: 0.28rem;
                height: 0.28rem;
                margin-right: 0.08rem;
            }
            .handle-label {
                font-size: 0.26rem;
                color: #666666;
            }
        }
    }
    .tabs {
        margin-top: 0.2rem;
        .van-tabs__wrap {
            height: 1rem;
            padding-bottom: 0.2rem;
            box-sizing: border-box;
            .van-tabs__nav {
                height: 0.8rem;
                padding-bottom: 0;
                .van-tab {
                    .van-tab__text {
                        color: #333333;
                        font-size: 0.3rem;
                    }
                    &.van-tab--active {
                        .van-tab__text {
                            color: #1D60AD;
                            font-weight: bold;
                        }
                    }
                }
                .van-tabs__line {
                    height: 0.03rem;
                    line-height: 0.03rem;
                    background-color: #1D60AD;
                    bottom: 0rem;
                }
            }
        }
        .van-tabs__content {
            height: calc(100vh - 0.88rem - 0.8rem - 0.2rem - 1rem);
            .van-tab__pane {
                height: 100%;
                .van-list {
                    height: 100%;
                    overflow-y: scroll;
                    .item {
                        padding: 0.28rem 0.32rem;
                        box-sizing: border-box;
                        background: #fff;
                        display: flex;
                        align-items: center;
                        .name-count {
                            flex: 1;
                            width: 0;
                            margin-right: 0.88rem;
                            .catename {
                                font-size: 0.3rem;
                                color: #333333;
                                line-height: 0.4rem;
                                margin-bottom: 0.1rem;
                            }
                            .datcount {
                                font-size: 0.24rem;
                                color: #999999;
                                line-height: 0.34rem;
                            }
                        }
                        .do-exam-icon-box {
                            width: 1rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            .do-exam-icon {
                                width: 0.46rem;
                                height: 0.46rem;
                                margin: 0 auto;
                            }
                            .again-exam {
                                width: 0.98rem;
                                height: 0.54rem;
                                background: #1D60AD;
                                border-radius: 1rem;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #fff;
                                font-size: 0.24rem;
                            }
                            .continue-exam {
                                width: 0.98rem;
                                height: 0.54rem;
                                background: #fff;
                                border: 0.02rem solid #1D60AD;
                                box-sizing: border-box;
                                border-radius: 1rem;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: #1D60AD;
                                font-size: 0.24rem;
                            }
                        }
                    }
                    .empty-data {
                        padding-top: 2rem;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        .icon {
                            width: 2.6rem;
                            height: 2.3rem;
                            margin-bottom: 0.15rem;
                        }
                        .text {
                            font-size: 0.28rem;
                            color: #999999;
                            line-height: 0.4rem;
                        }
                    }
                }
            }
        }
    }
}
</style>